(async function () {
  'use strict';

  const originalFetch = window.fetch;

  const MAX_CART_ITEMS = window.MAX_CART_ITEMS || 25;
  const MAX_CART_LIMIT_MESSAGE = window.MAX_CART_LIMIT_MESSAGE || `The maximum number of items in the cart is ${MAX_CART_ITEMS}`;

  const gifts = [
    { productId: window.BONUS_PRODUCT_ID_1, threshold: window.BONUS_THRESHOLD_1 || 30, variantId: null, handle: null },
    { productId: window.BONUS_PRODUCT_ID_2, threshold: window.BONUS_THRESHOLD_2 || 40, variantId: null, handle: null },
    { productId: window.BONUS_PRODUCT_ID_3, threshold: window.BONUS_THRESHOLD_3 || 50, variantId: null, handle: null }
  ].sort((a, b) => a.threshold - b.threshold);

  let isProcessingGift = false;

  async function getVariantId(productId) {
    try {
      const data = await fetch(`/products/${productId}.js`).then(r => r.json());
      return data.variants[0].id;
    } catch (e) {
      console.error('Variant load failed', e);
      return null;
    }
  }

  async function getProductHandle(productId) {
    try {
      const product = await fetch(`/products/${productId}.js`).then(r => r.json());
      console.log(product.handle)
      return product.handle;
    } catch (e) {
      console.error('Error fetching product handle:', e);
      return null;
    }
  }

  for (const gift of gifts) {
    gift.variantId = await getVariantId(gift.productId);
  }

  for (const gift of gifts) {
    gift.handle = await getProductHandle(gift.productId);
  }

  (function injectGiftStyles() {
    const style = document.createElement('style');
    style.innerHTML = gifts.map(g =>
      `.cart-item--product-${g.handle} cart-remove-button,
      .cart-item--product-${g.handle} .cart-item__quantity{ 
          display: none;
      }`
    ).join('\n');
    document.head.appendChild(style);
  })();

  async function getCart() {
    try {
      return await fetch('/cart.js').then(r => r.json());
    } catch {
      return { items: [], item_count: 0, total_price: 0 };
    }
  }

  async function updateDrawer() {
    console.log('Work')
    const drawer = document.getElementById('main-cart-drawer');
    if (!drawer) return;

    const sectionId =
      drawer.closest('[data-section-id]')?.dataset.sectionId ||
      drawer.dataset.sectionId ||
      'cart-drawer';

    const html = await fetch(`${location.pathname}?section_id=${sectionId}`).then(r => r.text());
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newDrawer = doc.getElementById('main-cart-drawer');

    if (!newDrawer) return;

    drawer.innerHTML = newDrawer.innerHTML;

    const cart = await getCart();
    drawer.classList.toggle('is-empty', cart.total_price === 0);

    const overlay = drawer.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.addEventListener('click', function() {
        drawer.close();
      });
    }
  }


  async function addGift(variantId) {
    if (!variantId) return;
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
  }

  async function removeGift(variantId) {
    const cart = await getCart();
    const item = cart.items.find(i => i.id === variantId);
    if (!item) return;

    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: 0 })
    });
  }

  function parseRequestBody(options) {
    if (!options?.body) return null;

    if (options.body instanceof FormData) {
      const data = {};
      for (const [k, v] of options.body.entries()) data[k] = v;
      return data;
    }
    try {
      return JSON.parse(options.body);
    } catch {
      return null;
    }
  }

  function showErrorMessage(message) {
    const wrapper = document.getElementById('cart-limit-error-wrapper');
    const msg = wrapper?.querySelector('#cart-limit-error-message');
    if (!wrapper || !msg) return;
    msg.textContent = message;
    wrapper.style.display = 'flex';
    setTimeout(() => (wrapper.style.display = 'none'), 5000);
  }

  window.fetch = async function (...args) {
    const url = args[0] instanceof Request ? args[0].url : args[0];
    const options = args[0] instanceof Request ? args[0] : args[1] || {};
    const method = options.method || 'GET';

    const isCartRequest =
      method === 'POST' &&
      (url.includes('/cart/add') ||
       url.includes('/cart/change') ||
       url.includes('/cart/clear'));

    if (url.includes('/cart/add')) {
      let qty = 1;
      if (options.body instanceof FormData) {
        qty = parseInt(options.body.get('quantity')) || 1;
      }
      const cart = await getCart();
      if (cart.item_count + qty > MAX_CART_ITEMS) {
        return new Response(JSON.stringify({
          error: MAX_CART_LIMIT_MESSAGE,
          description: MAX_CART_LIMIT_MESSAGE,
          status: 400
        }), {
          status: 400,
          headers: { 'Content-Type': 'application/json' }
        });
      }
    }

    if (url.includes('/cart/change')) {
      const body = parseRequestBody(options);
      if (body?.line) {
        const cart = await getCart();

        const index = body.line - 1;
        const item = cart.items[index];
        const prevQty = item.quantity;
        const newQty = +body.quantity;
        const diff = newQty - prevQty;

        if (cart.item_count + diff > MAX_CART_ITEMS) {

          const response = await originalFetch.apply(this, args);

          await originalFetch('/cart/change', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: item.key,
              quantity: prevQty
            })
          });

          setTimeout(async () => {
            await updateDrawer();
            showErrorMessage(MAX_CART_LIMIT_MESSAGE);
          }, 80);

          console.warn('MAX LIMIT', MAX_CART_ITEMS);
          return response;
        }
      }
    }

    const response = await originalFetch.apply(this, args);

    if (isCartRequest) {
      if (isProcessingGift) return response;
      isProcessingGift = true;

      const cart = await getCart();
      const total = cart.total_price / 100;

      let activeGift = null;
      for (const gift of gifts) {
        if (total > gift.threshold) activeGift = gift;
      }

      const cartGiftIds = new Set(gifts.map(g => g.variantId));
      const itemsInCart = cart.items.filter(i => cartGiftIds.has(i.id));

      for (const item of itemsInCart) {
        if (!activeGift || item.id !== activeGift.variantId) {
          await removeGift(item.id);
        }
      }

      if (activeGift && !itemsInCart.some(i => i.id === activeGift.variantId)) {
        await addGift(activeGift.variantId);
      }

      setTimeout(async () => {await updateDrawer()}, 80);

      isProcessingGift = false;
    }

    return response;
  };

})();
